import { map, withLatestFrom } from 'rxjs/operators';
import { Directive, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';

import { auth } from '../../store/auth/auth.selectors';
import { getAll, ORGANISATIONS } from '../../store/reducers';
import { GLOBAL_ROLES, ORGANISATION_ADMIN_ROLE } from '@careapp-group/core';
import { OrganisationDto } from '@careapp-group/ng-sdk';

/**
 * This directive hides content unless the user is either
 * a global admin, or is an ORG_ADMIN of at least 2 organisations
 */
@Directive({
    selector: '[isGroupAdmin]',
    standalone: false
})
export class GroupAdminDirective implements OnDestroy {
  userRoles: string[];

  isGroupAdmin = false;

  sub: any;

  constructor(
    public store: Store<any>,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {
    this.sub = this.store
      .select(getAll(ORGANISATIONS))
      .pipe(
        withLatestFrom(this.store.select(auth.getRoles)),
        map(([organisations, globalRoles]) => {
          if (globalRoles && globalRoles.some((r) => GLOBAL_ROLES.includes(r))) {
            return true;
          }
          const adminCount = organisations.reduce((count: number, org: OrganisationDto) => {
            if (org.roles && org.roles.includes(ORGANISATION_ADMIN_ROLE)) {
              return ++count;
            }
            return count;
          }, 0);
          // must be an admin of multiple
          return adminCount > 1;
        })
      )
      .subscribe((result) => {
        if (result !== this.isGroupAdmin) {
          this._updateView(result);
        }
        this.isGroupAdmin = result;
      });
  }

  private _updateView(showChild: boolean) {
    if (showChild) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
